import { Component } from '@angular/core';
import { ProgressIndicatorService } from '../progress-indicator/progress-indicator.service';

@Component({
  selector: 'app-access-denied',
  templateUrl: './access-denied.component.html'
})
export class AccessDeniedComponent {

  constructor(private _progressIndicatorService: ProgressIndicatorService,) {

    this._progressIndicatorService.show(false);}
}
